import { attendanceState, AttendanceState } from "./attendance.service";

export namespace Attendance {
    export namespace State {
        export const order = {
            [attendanceState.NOT_INTERESTED]: 0,
            [attendanceState.INTERESTED]: 1,
            [attendanceState.PENDING]: 2,
            [attendanceState.WAIT_LIST]: 3,
            [attendanceState.REGISTERED]: 4,
            [attendanceState.CHECKED_IN]: 5,
            [attendanceState.NO_SHOW]: 5,
            [attendanceState.CANCELED]: 5,
            [attendanceState.CHECKED_OUT]: 6,
        };

        export function isAtLeast(state: AttendanceState, minState: AttendanceState): boolean {
            return order[state] >= order[minState];
        }

        export function isAtMost(state: AttendanceState, minState: AttendanceState): boolean {
            return order[state] <= order[minState];
        }
    }
}
